module.exports = __webpack_public_path__ + "img/resolve3.fd7e3f3c.png";